import { useMemo } from "react";
import { useSelector } from "react-redux";
import { UserPermissions } from "../../../../../services/Api/Partner/partnerTypes";
import { selectIsAdmin, selectIsOffice } from "../../../../../services/users/selectors";

export const useUserPermissions = (permissions?: UserPermissions[]): Record<string, boolean> => {
	const isAdmin = useSelector(selectIsAdmin);
	const isOffice = useSelector(selectIsOffice);

	const hasMoneyFlowPermission = useMemo(
		() => !!permissions?.includes(UserPermissions.MONEY_FLOW) || isAdmin || isOffice,
		[permissions, isAdmin, isOffice]
	);
	const hasBasicPermission = useMemo(
		() => !!permissions?.includes(UserPermissions.BASIC) || isAdmin || isOffice,
		[permissions, isAdmin, isOffice]
	);
	const hasUsersPermission = useMemo(
		() => !!permissions?.includes(UserPermissions.USERS) || isAdmin || isOffice,
		[permissions, isAdmin, isOffice]
	);

	return {
		hasBasicPermission,
		hasUsersPermission,
		hasMoneyFlowPermission,
	};
};
